import useUserPermissions from "../../../../../common/utils/user/permissions/use-user-permissions";
import orderActiveListingUserPermissionDefinition from "./order-active-listing-user-permission";

const useOrderActiveListingUserPermissions = () => {
  return useUserPermissions(orderActiveListingUserPermissionDefinition);
};

export default useOrderActiveListingUserPermissions;
